import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { StarIcon } from './Icons';
export function HeroSection() {
  const {
    t,
    language
  } = useLanguage();
  const scrollToPackages = () => {
    const element = document.getElementById('packages');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  // Highlight the last word in red (e.g. "Rescued!" / "Rescatado!")
  const titleWords = t.hero.title.split(' ');
  const lastWord = titleWords[titleWords.length - 1];
  const restOfTitle = titleWords.slice(0, -1).join(' ');
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-473">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-474">
        <img src="https://cdn.magicpatterns.com/uploads/6KSoEhqdrnMbCV4vEWxDyy/hf_20260430_172717_43c485d5-a8dc-4f6b-b9e8-1d696bac11d8.png" alt="Move Fighters Team" className="w-full h-full object-cover object-center" data-id="element-475" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-black/70 via-brand-black/50 to-brand-black/30" data-id="element-476" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20" data-id="element-477">
        {/* 5-Star Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/15 rounded-full px-5 py-2.5 mb-8 shadow-xl" data-id="element-478">
          <div className="flex gap-0.5" data-id="element-479">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-brand-yellow fill-current" data-id="element-480" />)}
          </div>
          <span className="text-white text-sm font-bold tracking-wide" data-id="element-481">
            4.9/5
          </span>
          <span className="text-gray-300 text-sm" data-id="element-482">| 10,500+ Rescues</span>
        </motion.div>

        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-oswald text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.05] mb-6 uppercase drop-shadow-[0_4px_24px_rgba(0,0,0,0.6)]" data-id="element-483">
          {restOfTitle}{' '}
          <span className="text-brand-red drop-shadow-[0_2px_16px_rgba(220,38,38,0.5)]" data-id="element-484">
            {lastWord}
          </span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="text-lg sm:text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-485">
          {t.hero.subtitle}
        </motion.p>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.8,
        type: 'spring',
        stiffness: 200
      }} className="flex flex-col items-center gap-4" data-id="element-486">
          <button onClick={scrollToPackages} className="bg-brand-red hover:bg-brand-darkred text-white px-10 py-5 rounded-lg font-oswald font-bold text-xl tracking-wider uppercase transition-all transform hover:-translate-y-1 hover:shadow-2xl shadow-lg flex items-center gap-3" data-id="element-487">
            {t.hero.cta}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" data-id="element-488">
              <path d="M5 12h14" data-id="element-489" />
              <path d="m12 5 7 7-7 7" data-id="element-490" />
            </svg>
          </button>

          {/* Phone Call Button */}
          <a href="tel:8134768935" className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 text-white px-8 py-4 rounded-lg font-oswald font-bold text-lg tracking-wide uppercase transition-all hover:-translate-y-0.5" data-id="element-491">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" data-id="element-492">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-493" />
            </svg>
            (813) 476-8935
          </a>
        </motion.div>
      </div>
    </section>;
}